import { Component, input, model, output, viewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppleWifiProfilePreset, ConfigurationProfile } from '@rocksoft/mdm-sdk-v2';
import { Observable } from 'rxjs';
import { CommandSpinnerComponent } from '../../../utilities/command-spinner/command-spinner.component';
import { CommandProgress } from '../../../viewmodels/apple/signalr/command-context.model';
import { ConfigurationPayloadComponent } from '../../apple-profiles/profile-components/configuration-payload/configuration-payload.component';
import { ConfigurationProfileComponent } from '../../apple-profiles/profile-components/configuration-profile/configuration-profile.component';
import { WifiProfileComponent } from '../../apple-profiles/profile-components/wifi-profile/wifi-profile.component';

@Component({
  selector: 'ml-mdm-wifi-preset-install-ui',
  templateUrl: './wifi-preset-install.component.html',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    WifiProfileComponent,
    ConfigurationPayloadComponent,
    ConfigurationProfileComponent,
    CommandSpinnerComponent,
  ],
})
export class WifiPresetInstallComponent {
  private readonly configurationProfileComponent = viewChild.required(ConfigurationProfileComponent);
  private readonly wifiProfileComponent = viewChild.required(WifiProfileComponent);
  private readonly configurationPayloadComponent = viewChild.required(ConfigurationPayloadComponent);

  public readonly wifiProfiles = input<AppleWifiProfilePreset[]>([]);
  public readonly configurationProfile = model.required<ConfigurationProfile>();
  public readonly commandProgress = input.required<Observable<CommandProgress>>();

  public readonly installProfile = output<ConfigurationProfile>();
  public readonly updateWifiPreset = output<AppleWifiProfilePreset>();

  selectedProfile: AppleWifiProfilePreset;
  showMore = false;

  installPreset() {
    if (!this.configurationPayloadComponent().doneEditing() || !this.configurationProfileComponent().doneEditing()) {
      return;
    }

    if (this.selectedProfile) {
      this.configurationProfile().payloadContent = [this.selectedProfile];
      this.installProfile.emit(this.configurationProfile());
    }
  }
}
